export default "__VITE_ASSET__DOQTzjDo__"